import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addItemToCart,
  removeItemFromCart,
} from "../../Store/user/userSlice";

import styles from "../../styles/Cart.module.scss";
import { assetUrl } from "../../utils/imageUrl";
import { sumBy } from "../../utils/common";
import { Link } from "react-router-dom";
import { getUnitPriceForQuantity, isWholesalePriceApplied } from "../../utils/productPrice";

const Cart = () => {
  const dispatch = useDispatch();
  const { cart } = useSelector(({ user }) => user);

  const changeQuantity = (item, quantity) => {
    dispatch(addItemToCart({ ...item, quantity }));
  };

  const removeItem = (id) => {
    dispatch(removeItemFromCart(id));
  };

  return (
    <section className={styles.cart}>
      <h2 className={styles.title}>Ваш кошик</h2>

      {!cart.length ? (
        <div className={styles.empty}>Кошик порожній</div>
      ) : (
        <>
          <div className={styles.list}>
            {cart.map((item) => {
              const { title, category, images, price, id, quantity } = item;
              const unitPrice = getUnitPriceForQuantity(item, quantity);
              const wholesaleApplied = isWholesalePriceApplied(item, quantity);
              const lineTotal = unitPrice * quantity;

              return (
                <div className={styles.item} key={id}>
                  <div className={styles.image}>
                    <img src={assetUrl(images[0])} alt={title} />
                  </div>
                  <div className={styles.info}>
                    <h3 className={styles.name}>{title}</h3>
                    <div className={styles.category}>{category.name}</div>
                  </div>

                  <div className={styles.price}>
                    <div>{unitPrice}₴</div>
                    {wholesaleApplied && (
                      <div className={styles.retailPrice}>{price}₴</div>
                    )}
                  </div>

                  <div className={styles.quantity}>
                    <div
                      className={styles.minus}
                      onClick={() =>
                        changeQuantity(item, Math.max(1, quantity - 1))
                      }
                    >
                      <svg className="icon">
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/sprite.svg#minus`}
                        />
                      </svg>
                    </div>

                    <span>{quantity}</span>

                    <div
                      className={styles.plus}
                      onClick={() =>
                        changeQuantity(item, Math.max(1, quantity + 1))
                      }
                    >
                      <svg className="icon">
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/sprite.svg#plus`}
                        />
                      </svg>
                    </div>
                  </div>

                  <div className={styles.total}>{lineTotal}₴</div>

                  <div
                    className={styles.close}
                    onClick={() => removeItem(item.id)}
                  >
                    <svg className="icon">
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/sprite.svg#close`}
                      />
                    </svg>
                  </div>
                </div>
              );
            })}
          </div>

          <div className={styles.actions}>
            <div className={styles.total}>
              Разом:{" "}
              <span>
                {sumBy(cart.map((item) => getUnitPriceForQuantity(item, item.quantity) * item.quantity))}₴
              </span>
            </div>
            <Link to={`/checkout`}>
            <button className={styles.proceed}>Оформити замовлення</button>
            </Link>
          </div>
        </>
      )}
    </section>
  );
};

export default Cart;
